import { formatCurrency } from "@/utils/format/currency";
import { ProposalListItem } from "@/services/vision-service/types";

export const normalizeText = (text: string): string =>
  text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

export const getClientName = (proposal: ProposalListItem): string => {
  if (proposal.company_name && proposal.company_name.trim().length > 0) {
    return proposal.company_name;
  }
  return "—";
};

export const getAverageMonthlyValue = (
  proposal: ProposalListItem,
): number | null => {
  if (
    Array.isArray(proposal.space_adjustments) &&
    proposal.space_adjustments.length > 0
  ) {
    const validPrices = proposal.space_adjustments
      .map((adjustment) => adjustment.total_price)
      .filter((price): price is number => typeof price === "number");

    if (validPrices.length === 0) {
      return null;
    }

    const sum = validPrices.reduce((acc, value) => acc + value, 0);
    return sum / validPrices.length;
  }

  if (
    typeof proposal.current_monthly_cost === "number" &&
    Number.isFinite(proposal.current_monthly_cost)
  ) {
    return proposal.current_monthly_cost;
  }

  return null;
};

export { formatProposalDate } from "@/features/vision-360/utils/format-proposal-date";

export const formatAverageMonthlyValue = (value: number | null): string => {
  if (value === null) {
    return "—";
  }
  return formatCurrency(value);
};
